export default {"src":"/_next/static/media/visa.9791f5cc.svg","height":325,"width":1000,"blurWidth":0,"blurHeight":0};